function About() {
  return (
    <div className="about-page">
      <h1 data-aos="fade-up">More About Me</h1>

      <section data-aos="fade-up" data-aos-delay="100">
        <h2>How I Got Here</h2>
        <p>
          I got into computer science because I liked building things and immediately
          seeing the result. What started as small scripts and experiments slowly turned
          into larger systems, and I realized I enjoyed understanding how pieces fit
          together just as much as writing the code itself.
        </p>
      </section>

      <section data-aos="fade-up" data-aos-delay="200">
        <h2>How I Like to Work</h2>
        <p>
          I’m at my best when I have ownership over a problem and the space to explore
          solutions. I like breaking things down, reading existing code carefully, and
          asking questions early. When something breaks, I’m patient with debugging and
          try to understand the root cause instead of patching symptoms.
        </p>
      </section>

      <section data-aos="fade-up" data-aos-delay="300">
        <h2>What I Care About in Software</h2>
        <p>
          I care a lot about clarity and maintainability. Clean interfaces, predictable
          behavior, and readable code matter to me more than clever tricks. I enjoy working
          on systems that are simple on the surface but thoughtfully designed underneath.
        </p>
      </section>

      <section data-aos="fade-up" data-aos-delay="400">
        <h2>Beyond Code</h2>
        <p>
          Outside of traditional software work, I’m interested in game design and
          interactive systems. Thinking about pacing, feedback, and player experience has
          influenced how I approach UI, tooling, and even backend decisions.
        </p>
      </section>

      <section data-aos="fade-up" data-aos-delay="500">
        <h2>Right Now</h2>
        <p>
          Right now, I’m focused on becoming more comfortable with large codebases,
          improving how I design systems before I build them, and learning from working
          alongside more experienced engineers.
        </p>
      </section>
    </div>
  );
}

export default About;
